import styled from "styled-components";
import {
  color,
  compose,
  layout,
  position,
  space,
  typography,
} from "styled-system";

const Text = styled.div`
  color: ${({ theme }): string => theme.colors.black};
  letter-spacing: 0.01em;

  ${compose(color, layout, position, space, typography)};
`;

export default Text;
